import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {validateSelfEmployment} from '../../http';

export function useValidateSelfEmployment(
	options?: UseMutationOptions<void, unknown, void>,
): UseMutationResult<void, unknown, void> {
	return useMutation<void, unknown, void>(() => validateSelfEmployment().then(() => undefined), options);
}
